export default __webpack_public_path__ + "static/media/dashboard-background.d655ebee.png";